import MainContainer from './mainContainer';

export default MainContainer;
